export function computeRelativeTime(timeStr, publishedAt, isHistorical) {
  if (isHistorical || !publishedAt) return timeStr;
  try {
    const pubDate = new Date(publishedAt);
    if (isNaN(pubDate.getTime())) return timeStr;
    const diffMins = Math.max(0, Math.floor((Date.now() - pubDate.getTime()) / 60000));
    if (diffMins === 0) return 'ahora';
    if (diffMins < 60) return `hace ${diffMins} min`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `hace ${diffHours} hora${diffHours > 1 ? 's' : ''}`;
    const diffDays = Math.floor(diffHours / 24);
    return `hace ${diffDays} día${diffDays > 1 ? 's' : ''}`;
  } catch (e) {
    return timeStr;
  }
}

export function computeYesterdayFrom(editionDateStr) {
  if (!editionDateStr) return null;
  const MESES = {
    'enero': 0, 'febrero': 1, 'marzo': 2, 'abril': 3, 'mayo': 4, 'junio': 5,
    'julio': 6, 'agosto': 7, 'septiembre': 8, 'octubre': 9, 'noviembre': 10, 'diciembre': 11
  };
  // Esperamos formato: "30 de abril de 2026" o "Jueves, 30 de abril de 2026"
  const match = editionDateStr.trim().toLowerCase().match(/(?:[^,]+,\s*)?(\d{1,2})\s+de\s+(\w+)\s+de\s+(\d{4})/);
  if (!match) return null;
  const day = parseInt(match[1], 10);
  const month = MESES[match[2]];
  const year = parseInt(match[3], 10);
  if (month === undefined) return null;
  const editionDate = new Date(year, month, day);
  const yesterday = new Date(editionDate);
  yesterday.setDate(yesterday.getDate() - 1);
  const MESES_NOMBRES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  return `${yesterday.getDate()} de ${MESES_NOMBRES[yesterday.getMonth()]} de ${yesterday.getFullYear()}`;
}

export function ensureThreeHeroItems(hero = [], categories = []) {
  if (!Array.isArray(hero)) hero = [];
  const result = [...hero];
  
  if (result.length >= 3 || !Array.isArray(categories)) return result;

  for (const cat of categories) {
    if (cat.main) {
      let found = false;
      for (let i = 0; i < result.length; i++) {
        if (result[i].slug === cat.main.slug) {
          found = true;
          break;
        }
      }
      if (!found) {
        result.push(cat.main);
        if (result.length >= 3) return result;
      }
    }

    if (Array.isArray(cat.secondary)) {
      for (const sec of cat.secondary) {
        let found = false;
        for (let i = 0; i < result.length; i++) {
          if (result[i].slug === sec.slug) {
            found = true;
            break;
          }
        }
        if (!found) {
          result.push(sec);
          if (result.length >= 3) return result;
        }
      }
    }
  }

  return result;
}
